import qs from 'qs'

/**
 * Custom paramsSerializer for axios
 * @param {object} params The parameters to serialize
 * @returns {string} Query string without the leading `?`
 */
function defaultParamsSerializer(params) {
  return qs.stringify(params, { skipNulls: true, arrayFormat: 'comma' })
}

export { defaultParamsSerializer }
